import React from 'react'
import './service-card.scss';
import { GoDotFill } from "react-icons/go";
import { NavLink } from 'react-router-dom';


const InstallationCard = ({ data, re }) => {

    return (
        <div className="serviced-card-div green-color install-card">
            <NavLink to={''}>
                <div className="card-top">
                    <div className="left">
                        <p>{new Date(data?.date).toDateString()}</p>
                        {data?.prospect_id && <GoDotFill />}
                        {data?.prospect_id && <span className={`text-badge`}>{data?.prospect_id}</span>}
                    </div>
                    <div className={`right green-text`}>
                        <p>{!re ? 'INSTALLATION' : data?.work_type.toUpperCase()}</p>
                    </div>
                </div>
                <div className="card-content">
                    <div className="section-one-div">
                        {Number(data?.received_amount) ? <p className='amount'><span>₹</span>{data?.received_amount}</p> : ""}
                    </div>
                    <div className="section-two-div">
                        {data?.product_name_1
                            ? <p className='special'>{data?.product_name_1}<span>{'Product'}</span></p>
                            : <p className='special'>{data?.product_name_0}<span>{'Product'}</span></p>
                        }
                        {data?.site_category
                            && <p className='special'>{data?.site_category}<span>{'Usage'}</span></p>
                        }
                        {data?.description
                            && <p className='special'>{data?.description}<span>{'Decs'}</span></p>
                        }
                    </div>
                </div>
                <div className="card-bottom">
                    <div className="left">
                        <p>{data?.srl_number}</p>
                        {data?.re_filling_included && <GoDotFill />}
                        <p>{data?.re_filling_included && <span className={`text-badge`}>{'Refill Included'}</span>}</p>
                    </div>
                    <div className="rig">
                        <p>{data?.technician}</p>
                    </div>
                </div>
            </NavLink>
        </div>
    )
}

export default InstallationCard